var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TermsText",attrs:{"id":"Cookies-policy"},domProps:{"innerHTML":_vm._s(_vm.cookies)}})}
var staticRenderFns = []

export { render, staticRenderFns }